import React, { useState, useRef, createRef, useCallback, useEffect } from 'react';
import { Item, Wrapper, ItemList, Pill } from './style.js';

var SegmentedControlItem = React.forwardRef(function (_a, ref) {
    var label = _a.label, onClick = _a.onClick, selected = _a.selected, numOfItems = _a.numOfItems;
    return (React.createElement(Item, { ref: ref, onClick: onClick, selected: selected, numOfItems: numOfItems, role: "tab" }, label));
});
SegmentedControlItem.displayName = 'SegmentedControlItem';
function SegmentedControl(_a) {
    var items = _a.items, defaultItemId = _a.defaultItemId, onChange = _a.onChange, style = _a.style;
    var _b = useState(defaultItemId || items[0].id), selectedItemId = _b[0], setSelectedItemId = _b[1];
    var _c = useState({}), posXMap = _c[0], setPosXMap = _c[1];
    var itemListRef = useRef();
    var itemRef = useRef(items.map(function (_a) {
        var id = _a.id;
        return ({ id: id, ref: createRef() });
    }));
    var handleChange = function (id) {
        setSelectedItemId(id);
        if (onChange)
            onChange(id);
    };
    var updatePosX = useCallback(function () {
        var listRef = itemListRef.current;
        var refs = itemRef.current;
        var tmpPosXMap = {};
        refs.forEach(function (ref) {
            tmpPosXMap[ref.id] =
                ref.ref.current.getBoundingClientRect().x -
                    listRef.getBoundingClientRect().x;
        });
        setPosXMap(tmpPosXMap);
    }, []);
    useEffect(function () {
        updatePosX();
    }, [updatePosX]);
    useEffect(function () {
        window.addEventListener('resize', updatePosX);
        return function () { return window.removeEventListener('resize', updatePosX); };
    }, [updatePosX]);
    return (React.createElement(Wrapper, { style: style, "data-testid": "segmented-wrapper" },
        React.createElement(ItemList, { ref: itemListRef, role: "tablist" },
            React.createElement(Pill, { numOfItems: items.length, posX: posXMap[selectedItemId], "data-testid": "segmented-pill" }),
            items.map(function (_a) {
                var id = _a.id, label = _a.label;
                return (React.createElement(SegmentedControlItem, { key: id, ref: itemRef.current.find(function (ref) { return ref.id === id; }).ref, label: label, onClick: function () { return handleChange(id); }, selected: id === selectedItemId, numOfItems: items.length }));
            }))));
}

export { SegmentedControl as default };
